module.exports = __webpack_public_path__ + "assets/images/premium-features/slots-c46d3f.png";